module.exports = __webpack_public_path__ + "img/yourordermobile.1f243080.png";